<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="basic-data-tab" :class="{ 'form-disabled': disabled }">
    <div class="row">
      <div :class="isTableVisible(BASIC_DATA_TAB, CHARACTERISTIC_FIELD) ? 'col-md-6' : 'col-12'">
        <div class="card h-100">
          <div class="card-header py-3 pb-2" style="padding-left: 1rem">
            <div class="row align-items-center justify-content-between">
              <div class="col-12">
                <h6 class="mb-0 fw-semibold">Basic Data</h6>
              </div>
            </div>
          </div>

          <div class="card-body pt-2 card-body-tab" style="padding-left: 1rem">
            <!-- Field tampil/wajib/terkunci/opsi dari config FORM02 (BASIC_DATA); urutan & jenis input dari BASIC_FIELDS. -->
            <div class="row form-row-spacing">
              <template v-for="item in BASIC_FIELDS" :key="item.field">
                <div v-if="isFieldVisibleFn(item.field, BASIC_DATA_TAB)" :class="item.col || 'col-md-6'" class="mb-2">
                  <label class="mb-1">{{ item.label }} <span v-if="isFieldMandatoryFn(item.field, BASIC_DATA_TAB)" class="exclamation-mark-error-tab">*</span></label>

                  <!-- Select: opsi dari data_source config. Dataset besar (SEARCH_AS_YOU_TYPE_FIELDS) dicari ke server. -->
                  <div v-if="isSelectField(item.field)" class="d-flex align-items-center gap-1">
                  <SelectPrime show-clear v-model="mcrItem[item.field]" size="small" fluid filter class="flex-grow-1" style="min-width: 0"
                    :options="dialog.options[item.field]" option-label="label" option-value="value"
                    :placeholder="isFieldLocked(item.field, BASIC_DATA_TAB) ? '' : (item.placeholder || `Select ${item.label}`)"
                    :loading="dialog.loading[item.field]"
                    :disabled="isFieldReadOnly(item.field) || !isFieldDependencyReadyFn(item.field, BASIC_DATA_TAB)"
                    :invalid="hasErrorField(item.field) && !mcrItem[item.field]"
                    @show="onFieldOptionShow(item.field, BASIC_DATA_TAB, isSearchField(item.field) ? { search: '' } : {})"
                    @filter="isSearchField(item.field) && searchSelectFieldOptions($event, item.field, { tab: BASIC_DATA_TAB })"
                    @change="onFieldChange(item.field, BASIC_DATA_TAB)"
                  >
                    <template #value="{ value, placeholder }">
                      <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[item.field], value) }}</span>
                      <span v-else>{{ placeholder }}</span>
                    </template>
                    <template #emptyfilter>
                      <div v-if="dialog.loading[item.field]" class="d-flex align-items-center justify-content-center gap-2 py-2">
                        <i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
                      </div>
                      <div v-else class="py-1 text-muted text-center">No options found</div>
                    </template>
                    <template #empty>
                      <div v-if="dialog.loading[item.field]" class="d-flex align-items-center justify-content-center gap-2 py-2">
                        <i class="fas fa-spinner fa-spin"></i> <span>Loading...</span>
                      </div>
                      <div v-else class="py-1 text-muted text-center">No options found</div>
                    </template>
                  </SelectPrime>
                  <!-- Tombol Alternative UoM (config `alt_uom` di field, mis. UoM): buka popup Numerator / Denumerator. -->
                  <ButtonPrime v-if="altUomOf(BASIC_DATA_TAB, item.field)" icon="pi pi-link" size="small" outlined
                    v-tooltip.top="hasAltUomError(altUomOf(BASIC_DATA_TAB, item.field)) ? 'Alternative UoM: please complete the required fields' : 'Alternative UoM'"
                    :severity="hasAltUomError(altUomOf(BASIC_DATA_TAB, item.field)) ? 'danger' : undefined"
                    class="flex-shrink-0" :disabled="!canOpenAltUom(altUomOf(BASIC_DATA_TAB, item.field), mcrItem[item.field])"
                    @click="openAltUomPopup(altUomOf(BASIC_DATA_TAB, item.field), mcrItem[item.field])" />
                  </div>

                  <InputNumber v-else-if="item.type === 'number'" :model-value="toNumberValue(mcrItem[item.field])" size="small" fluid
                    :use-grouping="false" :min="0" :max-fraction-digits="item.fractionDigits" :placeholder="item.placeholder || item.label"
                    :disabled="isFieldReadOnly(item.field)"
                    :invalid="hasErrorField(item.field) && !mcrItem[item.field]"
                    @update:model-value="setFieldValue(item.field, $event)"
                  />

                  <PrimeTextarea v-else-if="item.type === 'textarea'" v-model="mcrItem[item.field]" rows="4" auto-resize fluid
                    :placeholder="item.placeholder || item.label"
                    :disabled="isFieldReadOnly(item.field)"
                    :invalid="hasErrorField(item.field) && !mcrItem[item.field]"
                    @update:model-value="delCertErrorVal(item.field)"
                  />

                  <div v-else-if="item.type === 'checkbox'" class="d-flex align-items-center" style="min-height: 32px">
                    <Checkbox v-model="mcrItem[item.field]" :binary="true" true-value="X" :false-value="null"
                      :disabled="isFieldReadOnly(item.field)"
                    />
                  </div>

                  <InputText v-else v-model="mcrItem[item.field]" size="small" fluid
                    :placeholder="isFieldLocked(item.field, BASIC_DATA_TAB) ? '' : (item.placeholder || item.label)"
                    :disabled="isFieldReadOnly(item.field)"
                    :invalid="hasErrorField(item.field) && !mcrItem[item.field]"
                    @update:model-value="delCertErrorVal(item.field)"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- Characteristic & Value: baris dari daftar characteristic Item Name + Item Type (config `rows_source`, dibuat ulang
           saat salah satunya diganti). Nilai boleh teks bebas (BE membuat nilai baru belum-approve) atau dipilih dari saran.
           Wajib per baris kalau is_mandatory YES; tambah/hapus baris cuma characteristic multiple (`row_actions.duplicate`). -->
      <div v-if="isTableVisible(BASIC_DATA_TAB, CHARACTERISTIC_FIELD)" class="col-md-6">
        <div class="card h-100">
          <div class="card-header py-3 pb-2" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">Characteristic &amp; Value</h6>
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="mcrItem[CHARACTERISTIC_FIELD] || []" scrollable scroll-height="520px" class="p-datatable-sm p-datatable-gridlines">
              <Column header="Characteristic" header-class="bg-light text-center" style="width: 45%">
                <template #body="{ data }">
                  {{ data.characteristic || data.cin_code || "-" }}
                  <span v-if="isCellMandatory(BASIC_DATA_TAB, CHARACTERISTIC_FIELD, 'cinv_code', data)" class="exclamation-mark-error-tab">*</span>
                </template>
              </Column>
              <Column header="Values" header-class="bg-light text-center">
                <template #body="{ data }">
                  <AutoComplete :model-value="columnTextValue(BASIC_DATA_TAB, CHARACTERISTIC_FIELD, 'cinv_code', data)"
                    :suggestions="dialog.suggestions" option-label="label" size="small" fluid placeholder="Input Value"
                    :auto-option-focus="false" complete-on-focus
                    :disabled="disabled || isColumnLocked(BASIC_DATA_TAB, CHARACTERISTIC_FIELD, 'cinv_code', data) || !isColumnEnabledFn('cinv_code', CHARACTERISTIC_FIELD, BASIC_DATA_TAB)"
                    :invalid="isColumnInvalidFn(data, 'cinv_code')"
                    @complete="searchColumnSuggestions(BASIC_DATA_TAB, CHARACTERISTIC_FIELD, 'cinv_code', data, $event)"
                    @option-select="onColumnSuggestionSelect(BASIC_DATA_TAB, CHARACTERISTIC_FIELD, 'cinv_code', data, $event)"
                    @update:model-value="onColumnTextInput(BASIC_DATA_TAB, CHARACTERISTIC_FIELD, 'cinv_code', data, $event)"
                  />
                </template>
              </Column>
              <Column header-class="bg-light text-center" body-class="text-center" style="width: 90px">
                <template #header>#</template>
                <template #body="{ data, index }">
                  <div class="d-flex align-items-center justify-content-center gap-2">
                    <ButtonPrime v-if="canDuplicateRow(BASIC_DATA_TAB, CHARACTERISTIC_FIELD, data)" icon="pi pi-plus" size="small" outlined rounded
                      :disabled="disabled" @click="duplicateRow(BASIC_DATA_TAB, CHARACTERISTIC_FIELD, data)" />
                    <ButtonPrime v-if="canRemoveTableRow(BASIC_DATA_TAB, CHARACTERISTIC_FIELD, data)" icon="pi pi-trash" size="small" outlined rounded
                      severity="danger" :disabled="disabled" @click="removeRow(CHARACTERISTIC_FIELD, index)" />
                  </div>
                </template>
              </Column>
              <template #empty>
                <div class="text-muted text-center small py-3">Select Item Name and Item Type to load characteristics.</div>
              </template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>

    <AlternativeUomPopup v-model:visible="dialog.altUom.visible" :rows="mcrItem.cat_emcr_alternative_uoms || []"
      :open-by="dialog.altUom.openBy" :readonly="disabled" />
  </div>
</template>

<script>
import formConfigHelper from "@/helpers/New_formConfig";
import { cataloguerTabMixin, useCataloguerTabEngine, createTabDialog } from "./New_CataloguerTab";
import AlternativeUomPopup from "./New_AlternativeUomPopup.vue";

// Key tab di FORM02_BASE.json
const BASIC_DATA_TAB = "BASIC_DATA";

// Field dataset besar (search-as-you-type): preload label cuma fetch 1 value yang cocok, bukan seluruh daftar --
// sama seperti SEARCH_AS_YOU_TYPE_FIELDS di McrItemFormDialog. Keputusan template, bukan JSON (DECISIONS_LOG.md).
const SEARCH_AS_YOU_TYPE_FIELDS = new Set(["cat_inc", "cat_uom", "cat_product_hierarchy", "cat_standard_description"]);

// Tabel Characteristic & Value (config BASIC_DATA.cat_emcr_characteristic_values): baris dibuat dari daftar characteristic
// Item Name + Item Type (`rows_source`), nilai = teks bebas + saran (kolom `cinv_code`, dicari per cin_code).
const CHARACTERISTIC_FIELD = "cat_emcr_characteristic_values";

// Layout card Basic Data (urutan, label, jenis input, lebar) -- hardcode di Vue sesuai prinsip "layout hardcode, behavior
// dynamic". Tampil/wajib/terkunci (`readonlyandsaved`)/opsi tiap field dari config FORM02. Jenis default = select kalau
// field punya data_source di config, selain itu InputText. Field terkunci tanpa data_source (Authorization Group, dst.)
// tampil sebagai InputText disabled berisi nilai dari config.
const BASIC_FIELDS = [
  { field: "material_number", label: "Material Number", type: "text" },
  { field: "service_number", label: "Service Number", type: "text" },
  { field: "cat_inc", label: "Item Name/Non Modifier", placeholder: "Search Item Name" },
  { field: "cat_item_type", label: "Item Type", placeholder: "Eg: OEM" },
  { field: "cat_material_type", label: "Material Type", placeholder: "Eg: RAW MATERIAL" },
  { field: "cat_material_group", label: "Material Group", placeholder: "Eg: FISHING VESSELS" },
  { field: "cat_service_category", label: "Service Category" },
  { field: "cat_service_group", label: "Service Group" },
  { field: "cat_uom", label: "UoM", placeholder: "Search UoM" },
  { field: "cat_valuation_class_service", label: "Valuation Class Service" },
  { field: "cat_lab_office", label: "Lab Office" },
  { field: "cat_product_hierarchy", label: "Product Hierarchy", placeholder: "Search Product Hierarchy" },
  { field: "cat_division", label: "Division" },
  { field: "cat_gen_item_cat_grp", label: "Gen. Item Cat. Group" },
  { field: "cat_trans_grp", label: "Transportation Group" },
  { field: "cat_standard_description", label: "Standard Description", placeholder: "Search Standard Description" },
  { field: "cat_currency", label: "Currency" },
  { field: "cat_price_unit", label: "Price Unit", type: "number" },
  { field: "cat_old_material_number", label: "Old Material Number", type: "text" },
  { field: "cat_ext_material_group", label: "Ext Material Group", type: "text" },
  { field: "cat_batch_management", label: "Batch Management", type: "checkbox" },
  { field: "cat_notes", label: "Notes", type: "textarea", col: "col-12" },
  { field: "specification", label: "Specification", type: "textarea", col: "col-12" },
  { field: "cat_industry_sector", label: "Industry Sector" },
  { field: "cat_expiration_date", label: "Expiration Date", type: "text" },
  { field: "cat_authorization_group", label: "Authorization Group", type: "text" },
  { field: "cat_manufacture_part_profile", label: "Manuf Part Profile", type: "text" },
  { field: "cat_purchasing_val_key", label: "Purchasing Val Key", type: "text" },
  { field: "cat_net_weight", label: "Net Weight", type: "number", fractionDigits: 3 },
  { field: "cat_weight_unit", label: "Unit of Weight", type: "text" }
];

// Props, setup engine, dialog, bind ke mcrItem, hasErrorField/delCertErrorVal, nilai terkunci: kerangka bersama
// New_CataloguerTab.js.
export default {
  name: "BasicDataTab",
  components: { AlternativeUomPopup },
  mixins: [cataloguerTabMixin],
  setup(props) {
    return useCataloguerTabEngine(props, { searchAsYouTypeFields: SEARCH_AS_YOU_TYPE_FIELDS });
  },
  data() {
    return {
      BASIC_DATA_TAB,
      BASIC_FIELDS,
      CHARACTERISTIC_FIELD,
      // Nilai Characteristic dicari per value saat item dibuka (bukan memuat seluruh daftar nilai per cin_code).
      searchAsYouTypeColumns: new Set([`${CHARACTERISTIC_FIELD}.cinv_code`]),
      dialog: createTabDialog(this.mcrItem, { suggestions: [] })
    };
  },
  methods: {
    isSearchField(field) {
      return SEARCH_AS_YOU_TYPE_FIELDS.has(field);
    },
    // Select = field ber-data_source di config (field lain di daftar layout tanpa `type` juga select).
    isSelectField(field) {
      const item = BASIC_FIELDS.find((f) => f.field === field);
      if (item?.type) return false;
      return !!formConfigHelper.getFieldConfig(this.formConfig, BASIC_DATA_TAB, field)?.data_source;
    },
    // Tidak bisa diedit: mode lihat-saja, `readonlyandsaved` (tetap disimpan), atau `enabled` false (dikosongkan BE).
    isFieldReadOnly(field) {
      return this.disabled || this.isFieldLocked(field, BASIC_DATA_TAB) || !this.isFieldEnabledFn(field, BASIC_DATA_TAB);
    },
    setFieldValue(field, value) {
      this.mcrItem[field] = value;
      this.delCertErrorVal(field);
    },
    // Hook kerangka bersama, dipanggil tiap item dipilih/berganti: label field select yang sudah berisi kode
    // di-resolve (opsi lazy-load, tanpa ini yang tampil cuma kode). Generic per config, bukan per field.
    // Lalu field ber-`auto_select_single` yang masih kosong dicoba dipilih otomatis (mis. INALUM MCR001: Material
    // Type/Group dengan opsi tunggal dari Item Name).
    // Tabel Characteristic yang masih kosong dibuat dari daftar characteristic Item Name + Item Type (`rows_source`).
    onItemBound() {
      this.preloadTabLabels(BASIC_DATA_TAB);
      this.autoSelectTabFields(BASIC_DATA_TAB);
      this.fillEmptySourcedRows(BASIC_DATA_TAB);
      // Baris Base UoM (Alternative UoM) dibuatkan dari UoM item kalau belum ada.
      this.syncAllAltUom();
      // Default ber-`when` (mis. Batch Management dari Material Type) ditulis ulang saat sumbernya berubah.
      this.watchFieldDefaultSources(BASIC_DATA_TAB);
    }
  }
};
</script>
